module.exports = __webpack_public_path__ + "static/media/icon_129.8306198b.svg";